







































































































































import { Component, Vue } from "vue-property-decorator";
import RetensiStore from "@/store/modules/RetensiAlihMediaStore";
import Service from "@/services/RetensiAlihMediaService";
import {
  KLASIFIKASI_LABELS,
  STATUS_LABELS,
  SessionStatus,
  KlasifikasiHasil,
} from "@/types/RetensiAlihMedia";

@Component({ name: "RetensiAlihMediaDaftarPage" })
export default class RetensiAlihMediaDaftarPage extends Vue {
  store = RetensiStore;

  filter: {
    status: SessionStatus | null;
    klasifikasi_hasil: Exclude<KlasifikasiHasil, null> | null;
    tanggal_dari: string | null;
    tanggal_sd: string | null;
  } = {
    status: null,
    klasifikasi_hasil: null,
    tanggal_dari: null,
    tanggal_sd: null,
  };

  statusOpts = Object.entries(STATUS_LABELS).map(([v, t]) => ({
    value: v,
    text: t,
  }));

  klasifikasiOpts = Object.entries(KLASIFIKASI_LABELS).map(([v, t]) => ({
    value: v,
    text: t,
  }));

  headers = [
    { text: "No. Session", value: "no_session" },
    { text: "Tanggal Audit", value: "tanggal_audit" },
    { text: "Periode Batch", value: "periode" },
    { text: "PMIK Pelaksana", value: "pmik_pelaksana_nama" },
    { text: "Status", value: "status" },
    { text: "% Kepatuhan", value: "persen_kepatuhan_total" },
    { text: "Temuan Kritis", value: "jumlah_temuan_kritis" },
    { text: "Aksi", value: "aksi", sortable: false, width: 140 },
  ];

  async mounted() {
    await this.refresh();
  }

  async refresh() {
    await this.store.fetchSessions(this.cleanFilter());
  }

  cleanFilter() {
    const out: Record<string, any> = {};
    for (const [k, v] of Object.entries(this.filter)) {
      if (v !== null && v !== "") out[k] = v;
    }
    return out;
  }

  openWizard() {
    this.$router.push({ name: "RetensiAlihMediaWizard" });
  }

  openDetail(id: number) {
    this.$router.push({ name: "RetensiAlihMediaDetail", params: { id: String(id) } });
  }

  openLaporanPdf(id: number) {
    window.open(Service.laporanPdfUrl(id), "_blank");
  }

  openExcel(id: number) {
    window.open(Service.excelUrl(id), "_blank");
  }

  formatDate(iso: string | null): string {
    if (!iso) return "—";
    return new Date(iso).toLocaleDateString("id-ID");
  }

  statusLabel(s: SessionStatus): string {
    return STATUS_LABELS[s] || s;
  }

  statusColor(s: SessionStatus): string {
    const map: Record<SessionStatus, string> = {
      draft: "grey",
      checklist_done: "blue",
      signed_pmik: "indigo",
      signed_auditor: "deep-purple",
      signed_karu_rm: "purple",
      signed_direktur: "teal",
      finalized: "green",
      locked: "green darken-2",
    };
    return map[s] || "grey";
  }

  klasifikasiColor(k: KlasifikasiHasil): string {
    if (!k) return "grey";
    return (
      {
        sangat_baik: "green",
        baik: "blue",
        cukup: "orange",
        kurang: "red",
      } as Record<string, string>
    )[k];
  }

  klasifikasiShort(k: KlasifikasiHasil): string {
    if (!k) return "—";
    return (
      {
        sangat_baik: "Sangat Baik",
        baik: "Baik",
        cukup: "Cukup",
        kurang: "Kurang",
      } as Record<string, string>
    )[k];
  }
}
